/**
 * The Feedback page's route (PLAN-SCORESHEETS S5).
 *
 * A sibling of `/batches/$batchId/brew` and wired the same way: the page itself
 * is router-free and takes its navigation as callbacks, so it renders in a test
 * without a memory router. "Print a card" hands the run to Task 8's sheet as one
 * comma-separated id, which is the shape that route validates back into ids.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BatchFeedbackPage } from '@/components/batches/batch-feedback';

export const Route = createFileRoute('/batches/$batchId/feedback')({
  component: BatchFeedbackRoute,
});

function BatchFeedbackRoute() {
  const { batchId } = Route.useParams();
  const navigate = useNavigate();
  return (
    // Keyed on the id because the router reuses this component when only the
    // param changes, and the page's hook (and its `drawn` ref) keep what they
    // had across an id change: without the key, one batch's sheets would stand
    // in for the next.
    <BatchFeedbackPage
      key={batchId}
      batchId={batchId}
      onBack={() => {
        void navigate({ to: '/batches/$batchId', params: { batchId } });
      }}
      onPrintCard={() => {
        void navigate({ to: '/batches/tasting-cards', search: { batches: batchId } });
      }}
    />
  );
}
